import { render, staticRenderFns } from "./PanelBalance.vue?vue&type=template&id=6904edd3&scoped=true&"
import script from "./PanelBalance.vue?vue&type=script&lang=js&"
export * from "./PanelBalance.vue?vue&type=script&lang=js&"
import style0 from "./PanelBalance.vue?vue&type=style&index=0&id=6904edd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904edd3",
  null
  
)

export default component.exports